module.exports = __webpack_public_path__ + "img/node-storage-transparent.ebe051b9.webp";